// In some instances, the default value is based on prior selected choices which are tracked in state.
// This helper function is used in the decorator.
// Takes a fieldId and in those cases where a conditional default value is required,
// it sets that default value based on the value in the store.
const determineDefaultValueWithState = (
  fieldId: string,
  formState: any,
  defaultValue: any
) => {
  switch (fieldId) {
    case 'levelofstudy':
      return formState &&
        (formState.visitortype === 'college_grad' ||
          formState.visitortype === 'parent_college_grad')
        ? JSON.stringify({ value: 'graduate', label: 'Graduate' })
        : JSON.stringify({ value: 'undergraduate', label: 'Undergraduate' });
    default:
      return defaultValue;
  }
};
// Decorate with defaults that are conditional on current form state
// TO DO: Excellent use case for rambda lens
// TO DO: Move some of these decorators into a memorized selector so that it's only done once
const decorateWithConditionalDefaultValues = (steps: any, formState: any) => {
  return steps.map((step: any) => {
    return {
      ...step,
      fields: step.fields.map((field: any) => {
        return {
          ...field,
          defaultValue: determineDefaultValueWithState(
            field.fieldId,
            formState,
            field.defaultValue
          ),
        };
      }),
    };
  });
};

export default decorateWithConditionalDefaultValues;
